export enum ButtonVariant {
    Primary = 'primary',
    PrimaryAlt = 'primary-alt',
    Secondary = 'secondary',
    Warn = 'warn',
    Text = 'text'
}

export enum ButtonSize {
    Medium = 'medium',
    Large = 'large',
    Small = 'small'
}

export enum ButtonLabel {
    Ok = 'OK',
    Cancel = 'Cancel',
    Proceed = 'Proceed',
    ADD_CATEGORY = 'Add Category',
    APPLY_CHANGES = 'Apply Changes',
    MAP_TO_GBB_PUBLIC = 'Map to GBB Public',
    RenewSession = 'Renew Session',
    DiscardChanges = 'Discard Changes',
    Logout = 'Logout',
    ClearPreview = 'Clear Preview',
    YES = 'Yes',
    NO = 'No',
    EXPORT_LIST = 'Export List'
}
